import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Store } from '@ngrx/store';

import { SecurityServerService } from './SecurityServerService';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { PermissionService } from './PermissionService';
import * as securityActions from '../../security/store/actions';
import { CurrentUserService } from './CurrentUserService';
import { forEach } from '@angular/router/src/utils/collection';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  
  constructor(private securityServerService: SecurityServerService,
    private permissionsService: PermissionService,
    private currentUserService: CurrentUserService,
    private store: Store<any>) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> | Observable<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.securityServerService.checkAuthentication()
        .then(() => {
          this.checkAuthentication(route, resolve, reject);
        });
    });
  }

  private checkPermissions(permissions: string[]): boolean {
    for (let index in permissions) {
      if (this.currentUserService.hasPermission(permissions[index])) {
        return true;
      }
    }
    return false;
  }

  private checkAuthentication(route: ActivatedRouteSnapshot, resolve, reject): void {
    if (!route.data.permissions) {
      resolve(true);
    }
    if (this.checkPermissions(route.data.permissions)) {
      resolve(true);
    } else if (this.currentUserService.userContext.loading || !this.currentUserService.userContext.isAuthenticated) {
      setTimeout(() => this.checkAuthentication(route, resolve, reject), 100);
    } else if (!this.currentUserService.checkPermissionsLoaded()) {
      this.permissionsService.getCurrentUserPermissions()
        .take(1)
        .subscribe(r => {
          if (!r.hasError) {
            this.store.dispatch(new securityActions.GetCurrentUserPermissionsSuccessAction({ permissions: r.model }));
          }
          this.checkAuthentication(route, resolve, reject);
        });
    } else {
      resolve(false);
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/security/services/AuthenticationGuard.ts